import {createAsyncThunk} from '@reduxjs/toolkit'

import {openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {ThunkApi} from '../interfaces'

const CULTURELAND_JOIN_URL = `https://www.cultureland.co.kr/register/terms.do`
const CULTURELAND_JOIN_MOBILE_URL = `https://m.cultureland.co.kr/mmb/signUpTerms.do`

/**
 * 컬쳐랜드 상품권 가입페이지로 이동
 */
const navigateToCultureLandJoinForm = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/cultureLandJoinForm',
    async () => {
        const url = isMobile ? CULTURELAND_JOIN_MOBILE_URL : CULTURELAND_JOIN_URL

        openNewTab({url})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToCultureLandJoinForm
